import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale lazy-chunk hashes after a redeploy.
const RELOAD_KEY = "__chunk_reload__";
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  if (!sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
});
window.addEventListener("error", (e) => {
  const msg = e.message || "";
  const isStaleChunk =
    msg.includes("dynamically imported module") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("Importing a module script failed") ||
    // React.lazy resolved to undefined because the lazy chunk hash no longer
    // exists after a redeploy: "can't access property \"default\", e._result is undefined"
    (msg.includes("_result") && msg.includes("undefined")) ||
    (msg.includes("default") && msg.includes("_result"));
  if (isStaleChunk) {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, "1");
      window.location.reload();
    }
  }
});
window.addEventListener("load", () => {
  setTimeout(() => sessionStorage.removeItem(RELOAD_KEY), 2000);
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
